<template>
  <div class="AddPattern">
    <box :title="patternTitle || $t('Pattern.newPattern')">
      <template v-if="patternTitle" slot="top-action-view">
        <v-btn rounded small outlined dark @click="resetItems"
          >{{ $t("Pattern.newPattern") }}
          <v-icon class="mr-2" small> mdi-chevron-left</v-icon>
        </v-btn>
      </template>

      <div class="d-flex pa-2">
        <div class="center">{{ $t("Pattern.patternTitle") }} :</div>
        <v-text-field
          :label="$t('Pattern.patternTitle')"
          solo
          hide-details=""
          v-model="patternTitle"
        ></v-text-field>
      </div>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn v-if="addPatternVisible" color="primary" @click="addPattern">{{
          $t("Pattern.addPattern")
        }}</v-btn>
        <v-btn
          v-if="patternPermissionVisible"
          color="primary"
          @click="patternPermission"
          >{{ $t("Pattern.patternPermission") }}</v-btn
        >
        <v-btn
          v-if="editPatternNameVisible"
          color="primary"
          @click="editPatternName"
          >{{ $t("Pattern.editPatternName") }}</v-btn
        >
        <v-btn
          v-if="deletePatternVisible"
          color="primary"
          @click="deletePattern"
          >{{ $t("Pattern.deletePattern") }}</v-btn
        >
      </v-card-actions>
    </box>

    <box
      v-if="patternList.length > 0"
      :title="$t('Pattern.patternList')"
      class="mt-2"
    >
      <div class="pa-2">
        <v-data-table
          dense
          :disable-sort="true"
          :headers="patternListHeader"
          :items="patternList"
          disable-pagination=""
          hide-default-footer
          @click:row="patternClick"
        />
      </div>
    </box>
  </div>
</template>

<script>
import ResultType from "../../../model/ResultType";
export default {
  data() {
    return {
      patternTitle: "",
      patternList: [],
      patternListHeader: [
        {
          text: this.$t("Pattern.patternTitle"),
          value: "PatternName",
        },
      ],
      addPatternVisible: true,
      patternPermissionVisible: false,
      editPatternNameVisible: false,
      deletePatternVisible: false,
      selectedPattern: {},
    };
  },
  mounted() {
    this.pageLoad();
  },
  methods: {
    pageLoad() {
      this.GetPatternList();
    },
    GetPatternList() {
      this.$store.dispatch("GetPatternList").then((result) => {
        //console.log(result);
        if (result.type === ResultType.success) {
          this.patternList = result.data.Table;
        }
      });
    },
    addPattern() {
      var name = this.patternTitle.trim();
      this.$store.dispatch("AddPattern", { name }).then((result) => {
        //console.log(result);
        if (result.type === ResultType.success) {
          //this.msg = result.data;
        }
        this.GetPatternList();
      });
    },
    patternClick(pattern) {
      //console.log(pattern);
      this.selectedPattern = pattern;
      this.patternTitle = this.selectedPattern.PatternName;
      this.addPatternVisible = false;
      this.patternPermissionVisible = true;
      this.editPatternNameVisible = true;
      this.deletePatternVisible = true;
    },
    patternPermission() {
      var query = {
        pid: this.selectedPattern.PatternId,
        pname: this.selectedPattern.PatternName,
      };
      this.$router.push({ name: "patternPermission", query: query });
    },
    editPatternName() {
      var payload = {
        id: this.selectedPattern.PatternId,
        name: this.patternTitle,
      };
      this.$store.dispatch("UpdatePatternName", { payload }).then((result) => {
        //console.log(result);
        if (result.type === ResultType.success) {
          //this.msg = result.data;
        }
        this.resetItems();
      });
    },
    deletePattern() {
      var patternId = this.selectedPattern.PatternId;
      this.$store.dispatch("DeletePattern", { patternId }).then((result) => {
        //console.log(result);
        if (result.type === ResultType.success) {
          //this.msg = result.data;
        }
        this.resetItems();
      });
    },
    resetItems() {
      this.addPatternVisible = true;
      this.patternPermissionVisible = false;
      this.editPatternNameVisible = false;
      this.deletePatternVisible = false;
      this.selectedPattern = {};
      this.patternTitle = "";
      this.GetPatternList();
    },
  },
};
</script>

<style>
</style>